
export default class OnlyRegistered {
    constructor() {
        this.addEvents();
    }

    addEvents() {
        $(document).ready(function () {
            $('.only-registered').each(function (i,e){
                const rect = this.getBoundingClientRect();
                $(this).find('a').attr('href', '');

                if($(this).attr('href')){
                    $(this).attr('href', '');
                }

                const textTooltip = $('.need-translate-reg').html();
                const tooltip =  $(`<div class="only-registered__popup">`+textTooltip+`</div>`);
                tooltip.appendTo($(this));
            })
            $('.only-registered-follow').each(function (i,e){
                const rect = this.getBoundingClientRect();
                $(this).find('a').attr('href', '');
                if($(this).attr('href')){
                    $(this).attr('href', '');
                }
                const tooltip = $(`<div class="only-registered__popup only-registered__popup-follow">Follow this author</div>`);
                tooltip.appendTo($(this));

            })

            $('.only-registered,.only-registered-follow,.register-popup').mouseenter(function () {
                const tooltip = $(this).find('.only-registered__popup')
                const rect = this.getBoundingClientRect();
            })
        })


    }

}